import React from 'react'
import { colors } from '../../Colors'

export interface IProps {
    width?: number
    height?: number
    color?: string
}

const ProductDocumentsIcon = ({ width = 24, height = 24, color = colors.grey[50] }: IProps) => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 24 24' fill='none'>
            <path
                d='M5.60039 2.39998C5.49438 2.39848 5.38913 2.41807 5.29076 2.4576C5.19238 2.49713 5.10284 2.55582 5.02735 2.63025C4.95185 2.70469 4.8919 2.79339 4.85099 2.89119C4.81007 2.989 4.789 3.09396 4.789 3.19998C4.789 3.306 4.81007 3.41097 4.85099 3.50877C4.8919 3.60658 4.95185 3.69527 5.02735 3.76971C5.10284 3.84415 5.19238 3.90283 5.29076 3.94237C5.38913 3.9819 5.49438 4.00148 5.60039 3.99998H18.4004C18.5064 4.00148 18.6117 3.9819 18.71 3.94237C18.8084 3.90283 18.8979 3.84415 18.9734 3.76971C19.0489 3.69527 19.1089 3.60658 19.1498 3.50877C19.1907 3.41097 19.2118 3.306 19.2118 3.19998C19.2118 3.09396 19.1907 2.989 19.1498 2.89119C19.1089 2.79339 19.0489 2.70469 18.9734 2.63025C18.8979 2.55582 18.8084 2.49713 18.71 2.4576C18.6117 2.41807 18.5064 2.39848 18.4004 2.39998H5.60039ZM5.60039 5.59998C4.72594 5.59998 4.00039 6.32553 4.00039 7.19998V12H5.60039V7.19998H18.4004V12H20.0004V7.19998C20.0004 6.32553 19.2748 5.59998 18.4004 5.59998H5.60039ZM2.40039 13.6V19.2C2.40039 20.5256 3.47479 21.6 4.80039 21.6H19.2004C20.526 21.6 21.6004 20.5256 21.6004 19.2V13.6H14.2535C13.9231 14.5304 13.0436 15.2 12.0004 15.2C10.9572 15.2 10.0777 14.5304 9.74727 13.6H2.40039Z'
                fill={color}
            />
        </svg>
    )
}

export default React.memo(ProductDocumentsIcon)
